import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { InviteMerchant } from "./components/InviteMerchant";
import { ManageInvites } from "./components/ManageInvites";
import { Merchants } from "./components/Merchants";
import { MerchantReport } from "./components/MerchantReport";
import { Healthz } from "./components/Healthz";
import { Login } from "./components/Login";
import { RequireAuth } from "./components/RequireAuth";
import { RequireMerchantAccess } from "./components/RequireMerchantAccess";
import { RequireTowpayAdmin } from "./components/RequireTowpayAdmin";
import { defaultPath, paths } from "./routes";

import "./bootstrap-icons.css";
import "./custom.css";

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Layout>
        <Routes>
          {/* Public. /healthz has to stay reachable for the container health check. */}
          <Route path={paths.healthz} element={<Healthz />} />
          <Route path={paths.login} element={<Login />} />

          {/* Outside the guards on purpose: redirecting first means a signed-out visitor
              reaches login with from=%2Fmerchants rather than from=%2F, and so lands
              somewhere real afterwards. The catch-all cannot shadow the two public paths
              above; React Router v6 picks by computed specificity, not source order, and
              "*" ranks last by construction. */}
          <Route path="/" element={<Navigate to={defaultPath} replace />} />
          <Route path="*" element={<Navigate to={defaultPath} replace />} />

          {/* Everything else requires a session, then a TowPay role. Nesting the guards
              as layout routes is what keeps the two public paths above out of their
              reach; a guard rendered beside the route table would redirect /login to
              itself. */}
          <Route element={<RequireAuth />}>
            <Route element={<RequireMerchantAccess />}>
              <Route path={paths.inviteMerchant} element={<InviteMerchant />} />
              <Route path={paths.inviteHistory} element={<ManageInvites />} />
              <Route path={paths.merchants} element={<Merchants />} />
              {/* Admin only: the report lists every merchant's contact email and
                  pricing, and the API refuses anyone else anyway. */}
              <Route element={<RequireTowpayAdmin />}>
                <Route path={paths.merchantReport} element={<MerchantReport />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </Layout>
    );
  }
}
